import toast from "react-hot-toast";

export const swiggyPrintBillPartner = ({ items, subtotal, total, orderId }) => {
    const date = new Date();
    const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    const formattedTime = date.toLocaleTimeString();
  
    // Generate the HTML for the bill
    const billHTML = `
      <html>
        <head>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 0;
              padding: 10px;
            }
            h2 {
              text-align: center;
              margin: 0 0 10px 0;
              font-size: 18px;
            }
            .details {
              margin-bottom: 10px;
              font-size: 14px;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
            }
            th, td {
              padding: 8px;
            }
            th {
              text-align: left;
              background-color: #f2f2f2;
            }
            td {
              vertical-align: top;
            }
            .addon {
              font-size: 12px;
              font-style: italic;
              color: #555;
              padding-left: 10px;
            }
            .totals {
              margin-top: 20px;
              font-size: 16px;
              font-weight: bold;
            }
            .totals div {
              margin-bottom: 5px;
            }
          </style>
        </head>
        <body>
          <h2>Bill</h2>
          <div class="details">
            <p><strong>Date:</strong> ${formattedDate}</p>
            <p><strong>Time:</strong> ${formattedTime}</p>
            <p><strong>Order ID:</strong> ${String(orderId).slice(-4)}</p>
          </div>
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Add-ons</th>
                <th>Quantity</th>
                <th>Price</th>
              </tr>
            </thead>
            <tbody>
              ${items
                .map((item) => `
                  <tr>
                    <td>${item.name}</td>
                    <td>
                      ${item.addons
                        ? item.addons
                            .map(
                              (addon) => `
                              <div class="addon">${addon.name} (₹${addon.price})</div>
                            `
                            )
                            .join('')
                        : '-'}
                    </td>
                    <td>${item.quantity}</td>
                    <td>₹${item.total}</td>
                  </tr>
                `)
                .join('')}
            </tbody>
          </table>
          <div class="totals">
            <div><strong>Subtotal:</strong> ₹${subtotal}</div>
            <div><strong>Total:</strong> ₹${total}</div>
          </div>
        </body>
      </html>
    `;
  
    // Open a new window and print the bill
    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(billHTML);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };
  